import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label, Modal } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchBenchmarkCalculationParameterRequest } from './action'

const required = value => value ? null : 'Required';
const isValid = value => !value || value.match(/^[^<>!$%^?*~`{}=]*$/) ? null : 'Please enter valid Input';

const renderField = ({ input, label, type, isRequired, disabled, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} disabled={disabled} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class AutomatedBenchmarkForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialData: []
        }
    }

    componentDidMount() {
        //this.props.load(this.props.initialValues);
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {

        }
    }

    submitParameters = (val) => {
        if (val.nicCode === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Please Enter NIC Code.
                </div>
            );
        } else {
            this.props.createBencmarkRequestBody(val);
        }
    }

    render() {
        const { handleSubmit, pristine, submitting, reset } = this.props
        return (
            <Row>
                <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => this.submitParameters(val))}>

                    <ModalHeader>
                        Automated Benchmark calulation Parameters
                    </ModalHeader>
                    <ModalBody>
                        <Field
                            name="nicCode"
                            type="text"
                            component={renderField}
                            label="NIC Code"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleSectionEditToggle()} > Cancel </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" disabled={submitting}>Submit</Button></Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Row>
        )
    }
}

AutomatedBenchmarkForm = reduxForm({
    form: 'automatedBenchmarkForm', // a unique identifier for this form
    enableReinitialize: true
})(AutomatedBenchmarkForm);

AutomatedBenchmarkForm = connect(
    state => ({
        initialValues: state.automatedBenchmarkData.benchmarkCalculationParams // pull initial values from reducer
    }),
    { load: fetchBenchmarkCalculationParameterRequest }, // bind addition fields loading action creator
)(AutomatedBenchmarkForm);

export default AutomatedBenchmarkForm;
